/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupMark = zod
  .object({
    date: zod.iso.date(),
    kind: zod.enum(['read', 'write', 'math']),
    lineageUuid: zod.uuid(),
    leaderActorUuid: zod.uuid(),
    changedAt: zod.iso.datetime({ offset: true }),
  })
  .describe('A mark made in this group that still says done');

export type GroupMark = zod.input<typeof GroupMark>;
export type GroupMarkOutput = zod.output<typeof GroupMark>;
